<template>
  <Dialog
    v-model:visible="modelValue"
    modal
    class="text-surface-950"
    :draggable="false"
    :pt="props.testId ? { root: { 'data-testid': props.testId } } : undefined"
    @hide="emit('hide')"
  >
    <template #container="{ closeCallback }">
      <div class="flex items-center justify-between gap-8 p-5">
        <div class="flex items-center gap-4">
          <div
            v-if="$slots.icon"
            class="grid size-12 place-items-center rounded-full border border-surface-200 text-surface-600"
          >
            <slot name="icon" />
          </div>
          <div class="space-y-1">
            <div class="font-medium">{{ header }}</div>
            <div v-if="description" class="text-sm text-surface-600">
              {{ description }}
            </div>
          </div>
        </div>
        <button
          type="button"
          :aria-label="$t('global.actions.close')"
          @click="closeCallback"
          class="-m-1 rounded-md p-1 hover:bg-surface-50"
        >
          <RiCloseLine class="size-5" />
        </button>
      </div>
      <div class="overflow-y-auto border-t border-surface-200 p-5">
        <slot />
      </div>
      <div v-if="$slots.footer" class="border-t border-surface-200 p-5">
        <slot name="footer" />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import RiCloseLine from '~icons/ri/close-line'

const modelValue = defineModel<boolean>()

const props = defineProps<{
  header: string
  description?: string
  testId?: string
}>()

const emit = defineEmits<{
  (e: 'hide'): void
}>()
</script>
